import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import axios from "axios";
import Timer from "@/components/quiz/Timer.vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import { Component, Prop, Ref, Vue } from "vue-facing-decorator";
import QuizViewerLayout from "@/components/layout/QuizViewerLayout.vue";
import QuizViewerCarousel from "@/components/quiz/QuizViewerCarousel.vue";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import QuizPreamble from "@/components/quiz/QuizPreamble.vue";
import InformationDialog from "@/components/dialogs/NotificationDialog.vue";
import SurveyQuiz from "@/components/quiz/SurveyQuiz.vue";
import { Events } from "@/events/events";
let SurveyQuizPlayer = class SurveyQuizPlayer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quizId", void 0);
    _defineProperty(this, "quizResultJsonString", void 0);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "remainingSeconds", void 0);
    _defineProperty(this, "isSpeachTemplate", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "timerComponent", void 0);
    _defineProperty(this, "surveyQuizViewerCarousel", void 0);
    _defineProperty(this, "quiz", void 0);
    _defineProperty(this, "timeElapsed", false);
    _defineProperty(this, "BASE_API_QUIZ", '/api/v2/quiz');
    _defineProperty(this, "activeStep", 0);
    _defineProperty(this, "quizAnswered", false);
    _defineProperty(this, "realtimeUserAnswers", null);
  }
  mounted() {
    this.getQuiz();
    if (this.quizResultJsonString) {
      this.quizAnswered = true;
      this.realtimeUserAnswers = JSON.parse(this.quizResultJsonString);
    }
  }
  unmounted() {
    if (this.timer && this.timerComponent.getRemainingSeconds() > 0) {
      this.timerComponent.stopCounting();
    }
  }
  get preambleItems() {
    const preambleItems = [this.$t('view.speach.surveyQuiz.start.text1', {
      nbQuestions: this.quiz?.nbQuestions
    }), this.timer ? this.$t('view.speach.surveyQuiz.start.text2', {
      minutes: this.timer
    }) : this.$t('view.speach.surveyQuiz.start.text3'), this.$t('view.speach.surveyQuiz.start.text4'), this.$t('view.speach.surveyQuiz.start.textWarning')];
    return preambleItems;
  }
  get footerButtonLabel() {
    switch (this.activeStep) {
      case 0:
        return this.$t('view.speach.surveyQuiz.start.startButton').toString();
      default:
        return this.$t('view.speach.surveyQuiz.start.nextStepButton').toString();
    }
  }
  get isPreambleSlide() {
    return !this.quizAnswered && this.activeStep === 0;
  }
  onSlideChange(eventData) {
    this.activeStep = eventData.currentSlideIndex;
  }
  getQuiz() {
    axios.get(`${this.BASE_API_QUIZ}/${this.quizId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.quiz = response.data;
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
  onQuizAnswerChange(userAnswers) {
    this.realtimeUserAnswers = userAnswers;
  }
  async saveUserAnswers() {
    await axios.put(`${this.BASE_API_QUIZ}/${this.quizId}/survey-answers`, {
      userAnswersJson: JSON.stringify(this.realtimeUserAnswers)
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).catch(e => {
      throw new Error(e);
    });
  }
  async onNextStepButtonClick() {
    switch (this.activeStep) {
      case 0:
        if (this.timer) {
          this.timerComponent.startCounting();
        }
        this.moveToNextSlide();
        trig(Events.STAT_START);
        break;
      case 1:
        if (this.timer && this.timerComponent.getRemainingSeconds() > 0) {
          this.timerComponent.stopCounting();
        }
        await this.saveAnswerAndDisplayResultPage();
        break;
    }
  }
  async saveAnswerAndDisplayResultPage() {
    try {
      if (!this.canEdit) {
        await this.saveUserAnswers();
      }
      this.quizAnswered = true;
    } catch (e) {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    }
  }
  moveToNextSlide() {
    this.surveyQuizViewerCarousel?.next();
  }
  countdownEnd() {
    this.timeElapsed = true;
    this.saveAnswerAndDisplayResultPage();
  }
};
__decorate([Prop({
  required: true
})], SurveyQuizPlayer.prototype, "quizId", void 0);
__decorate([Prop({
  default: ''
})], SurveyQuizPlayer.prototype, "quizResultJsonString", void 0);
__decorate([Prop({
  default: 0
})], SurveyQuizPlayer.prototype, "timer", void 0);
__decorate([Prop({
  default: 0
})], SurveyQuizPlayer.prototype, "remainingSeconds", void 0);
__decorate([Prop({
  default: false
})], SurveyQuizPlayer.prototype, "isSpeachTemplate", void 0);
__decorate([Prop({
  default: false
})], SurveyQuizPlayer.prototype, "canEdit", void 0);
__decorate([Ref('timerComponent')], SurveyQuizPlayer.prototype, "timerComponent", void 0);
__decorate([Ref('surveyQuizViewerCarousel')], SurveyQuizPlayer.prototype, "surveyQuizViewerCarousel", void 0);
SurveyQuizPlayer = __decorate([Component({
  components: {
    SurveyQuiz,
    QuizPreamble,
    QuizViewerCarousel,
    QuizViewerLayout,
    InformationDialog,
    Pagination,
    Navigation,
    Slide,
    Carousel,
    Timer,
    StandardButton
  }
})], SurveyQuizPlayer);
export default SurveyQuizPlayer;